// Third-party
import React from 'react';
import classNames from 'classnames';

type Props = {
  text: string;
  color?: string;
  className?: string;
};

const FlagLabel = ({ text, color, className }: Props) => (
  <div className={classNames('flag-label', className, color)}>
    <span>{text}</span>
  </div>
);

export default FlagLabel;
